"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const TradeInQuotationQuery = (0, graphql_tag_1.default) `
  fragment TradeInQuotation on FindTradeInQuotationResponse {
    id
    title
    subtext
    promotionText
  }

  fragment TradeInQuotationError on TradeInErrorResponse {
    message
    detail
    error
  }

  query TradeInQuotationQuery($request: TradeInFindQuotationsRequest!) {
    findTradeInQuotation(request: $request) {
      ...TradeInQuotation
      ...TradeInQuotationError
    }
  }
`;
exports.default = TradeInQuotationQuery;
